<div class="overlay" *ngIf="show">
    <div class="popup">
      <h2>Warning!</h2>
      <p>{{ message }}</p>
      <button (click)="closePopup()">Try Again</button>
    </div>
  </div>